export class TenantCommonData {
  id?: number;
  tenantId?: number;
  dateCreated?: Date;
  lastUpdated?: Date;

  constructor() {
    this.id = null;
    this.tenantId = -1;
    this.dateCreated = null;
    this.lastUpdated = null;
  }
}
